export enum Velo {
  VeloMecanique = "velo_mecanique",
  VeloElectrique = "velo_electrique",
  VeloCargo = "velo_cargo",
  VeloCargoElectrique = "velo_cargo_electrique",
  VeloPliant = "velo_pliant",
  VeloPliantElectrique = "velo_pliant_electrique",
  VeloMotorisation = "velo_motorisation",
  VeloAdapte = "velo_adapte",
}
